import { authenticatedFetch } from '../../../shared/utils/authenticatedFetch';
import type { TACockpitData } from '../types/taCockpit';

const PROXY_URL =
  import.meta.env.VITE_PROXY_URL ||
  'https://proxy-prod-people-520260363689.europe-west3.run.app';

export async function fetchTACockpitData(): Promise<TACockpitData> {
  const res = await authenticatedFetch(`${PROXY_URL}/api/ta-cockpit/data`);
  if (!res.ok) {
    throw new Error(`TA Cockpit fetch failed: ${res.status}`);
  }
  return res.json();
}
